import { render, staticRenderFns } from "./LearnMore.vue?vue&type=template&id=651bb4e3&scoped=true"
import script from "./LearnMore.vue?vue&type=script&lang=ts"
export * from "./LearnMore.vue?vue&type=script&lang=ts"
import style0 from "./LearnMore.vue?vue&type=style&index=0&id=651bb4e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651bb4e3",
  null
  
)

export default component.exports